import fetch from "./fetch";
/**
 * 考试相关
 */
const examManage = {
  //试题列表
  examListRequest(params) {
    return fetch({
      isLoading: true,
      url: "/exam/page",
      method: "GET",
      params,
    });
  },

  //新增考试
  examSaveRequest(data) {
    return fetch({
      isLoading: true,
      url: "/exam/save",
      method: "POST",
      data,
    });
  },

  //编辑试题
  examUpdateRequest(data) {
    return fetch({
      isLoading: true,
      url: "/exam/update",
      method: "POST",
      data,
    });
  },

  // 考试记录
  examRecordRequest(params) {
    return fetch({
      isLoading: true,
      url: "/examRecord/page",
      method: "GET",
      params,
    });
  },
};

export default examManage;
